import React, { useEffect, useRef, useState } from "react";
import Loader from "../icons/Loader";

const InfiniteScroller = ({
  className,
  items,
  renderer,
  getData,
  loading,
  hasMore,
  rootRef, // optional: scroll container to observe within
}) => {
  const loaderRef = useRef(null);
  const requestInFlightRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting && !loading && hasMore && !requestInFlightRef.current) {
          requestInFlightRef.current = true;
          getData(); // Trigger fetching more data
        }
      },
      {
        root: rootRef?.current || null,
        rootMargin: "200px",
        threshold: 0.1,
      }
    );



    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.disconnect();
      }
    };
  }, [loading, hasMore, rootRef?.current]);

  // reset request lock when loading completes
  useEffect(() => {
    if (!loading) {
      requestInFlightRef.current = false;
    }
  }, [loading]);

  // console.log("hasMore :", hasMore);

  return (
    <div className={className}>
      {items.map((item, index) => renderer(item, index))}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      )}
      {hasMore && (
        <div
          style={{
            height: "100px", // Larger trigger area
            marginTop: "var(--inyc-space-20)",
            marginBottom: "100px",
          }}
          ref={loaderRef}
        >
        </div>
      )}
    </div>
  );
};

export default InfiniteScroller;
